import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { supabase } from './lib/supabase';
import Login from './pages/auth/Login';
import SignUp from './pages/auth/SignUp';
import TripPage from './pages/TripPage';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import EditTripPage from './pages/EditTripPage';
import AuthCallback from './pages/auth/AuthCallback';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check active sessions and sets the user
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    // Listen for changes on auth state (sign in, sign out, etc.)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={user ? <Navigate to="/trips" replace /> : <LandingPage />} />
        <Route path="/trips" element={user ? <HomePage /> : <Navigate to="/login" replace />} />
        <Route
          path="/login"
          element={user ? <Navigate to="/trips" replace /> : <Login />}
        />
        <Route
          path="/signup"
          element={user ? <Navigate to="/trips" replace /> : <SignUp />}
        />
        <Route
          path="/trips/new"
          element={user ? <TripPage isNew={true} /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/trips/:id"
          element={user ? <TripPage /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/trips/:id/edit"
          element={user ? <EditTripPage /> : <Navigate to="/login" replace />}
        />
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
    </Router>
  );
}

export default App;
